// config/loaderConfig.js

const wordSets = {
  // Web Vulnerabilities
  web_vul: [
    "Injection",
    "Open Redirect",
    "Tampering",
    "XSS",
    "CSRF",
    "IDOR",
    "SSRF",
    "Response Splitting",
    "Directory Traversal",
    "Session Fixation",
    "Phishing URL",
  ],

  // Network Vulnerabilities
  network_vul: [
    "IP Address",
    "IPv4",
    "IPv6",
    "Subnet Mask",
    "Gateway",
    "DNS",
    "DHCP",
    "NAT",
    "CIDR",
    "Public IP",
    "Private IP",
    "MAC Address",
  ],

  // AWS
  aws: {
    misconfig: [
      "Over-Permissive Roles",
      "Public S3 Buckets",
      "Unrestricted Groups",
      "Disabled MFA",
      "Exposed RDS",
      "Unencrypted EBS",
      "Leaky API",
      "Default Keys",
      "Anonymous Policies",
    ],
    network_vul: [
      "Open EC2 Ports",
      "Exposed VPC",
      "Overly Permissive NACLs",
      "Unrestricted ELB Access",
      "Weak VPN Config",
      "Leaky Route 53",
      "Unmonitored Transit",
    ],
    web_vul: [
      "Exposed S3 Bucket",
      "Unsecured API Gateway",
      "CORS Misconfigurations",
      "Weak Cognito Auth",
      "Unencrypted Lambda URLs",
      "Open Elastic Beanstalk",
    ],
  },

  // Azure
  azure: {
    misconfig: [
      "Over-Permissive RBAC Roles",
      "Public Blob Containers",
      "Open Network Security Groups",
      "Disabled Azure MFA",
      "Exposed SQL Databases",
      "Unencrypted Managed Disks",
      "Weak Key Vault Policies",
      "Anonymous Shared Access Signatures",
      "Default Admin Accounts",
      "Misconfigured Application Gateway",
    ],
    network_vul: [
      "Exposed Virtual Networks",
      "Unrestricted NSG Rules",
      "Open VPN Gateway Ports",
      "Weak Azure Firewall Configurations",
      "Exposed Private Link Services",
      "Unrestricted ExpressRoute Connections",
    ],
    web_vul: [
      "Exposed App Services",
      "Unsecured Azure Functions",
      "Weak API Management Policies",
      "CORS Misconfigurations on Azure CDN",
      "Open Logic Apps Endpoints",
      "Publicly Accessible Web Apps",
    ],
  },

  // GCP
  gcp: {
    misconfig: [
      "Over-Permissive IAM Bindings",
      "Public Cloud Storage Buckets",
      "Open Firewall Rules",
      "Disabled 2FA for Cloud Identity",
      "Exposed Cloud SQL Instances",
      "Unencrypted Persistent Disks",
      "Weak Service Account Keys",
      "Default Compute Engine Accounts",
      "Anonymous BigQuery Access",
      "Misconfigured HTTPS Load Balancers",
    ],
    network_vul: [
      "Open VPC Firewall Rules",
      "Exposed Cloud Interconnect",
      "Unrestricted Cloud VPN Access",
      "Leaky Cloud DNS Records",
      "Exposed Internal Load Balancers",
      "Unmonitored Peering Connections",
    ],
    web_vul: [
      "Publicly Accessible Cloud Functions",
      "Unsecured Cloud Run Services",
      "Open App Engine Endpoints",
      "CORS Issues on Cloud CDN",
      "Weak Identity-Aware Proxy Configs",
      "Leaky Firebase Hosting URLs",
    ],
  },
};

export default wordSets;
